const ApiAttributesKeys = {
  chapterIdKey: 'chapterId',
  readingNameKey: 'name',
  correctChoiceKey: 'right_choice',
  readingIdKay: 'readingId',
  readingIdParamsKey: 'readingId',
  questionIdKey: 'id',
  questionIdParamsKey: 'questionId',
  answerKey: 'answer',
  questionKey: 'question',
  isAttemptedKey: 'isAttempted',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/QuestionBank/QuestionView/ApiAttributesKeys.js